// Using native img as next handles svg weirdly
/* eslint-disable @next/next/no-img-element */
import cx from 'classnames';
import EggOutline from 'themes/organic/assets/organic_egg_outline.svg';

import s from './EggShapedPicture.module.css';

export interface EggShapedPictureProps {
  src: string;
  className?: string;
  outline?: boolean;
  alt?: string;
}

const EggShapedPicture = ({
  className,
  src,
  alt,
  outline,
}: EggShapedPictureProps) => {
  return (
    <div className={cx(s.eggShapedPicture, className)}>
      {outline && <EggOutline />}
      <div
        className={s.picture}
        style={{
          backgroundImage: `url(${src})`,
        }}
        role="img"
        aria-label={alt}
        title={alt}
      />
    </div>
  );
};

export { EggShapedPicture };
